import dashboard from './dashboard'

const mod = {
    namespaced: true,
    modules: {
        dashboard: dashboard
    }
};

export default mod;
